import CommonFunction from '@/common/commonFunction';

import { defaultTaxRegisState } from './module-taxregis-state';

export default {
	resetState(state) {
		Object.assign(state, defaultTaxRegisState);
	},
	updateTaxReturnRegis(state, res) {
		CommonFunction.genVKeyValue(res.Data);
		state.TaxRegisData.removeAll();
		state.TaxRegisData.append(res.Data);
		state.Total = res.Total;
	},
	updateHadRegisteredDeclaration(state, res) {
		state.hadRegisteredDeclaration = res;
	}
};
